import { render, staticRenderFns } from "./GoldDripLanding.vue?vue&type=template&id=649d09cc&scoped=true&"
import script from "./GoldDripLanding.vue?vue&type=script&lang=js&"
export * from "./GoldDripLanding.vue?vue&type=script&lang=js&"
import style0 from "./GoldDripLanding.vue?vue&type=style&index=0&id=649d09cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d09cc",
  null
  
)

export default component.exports